import { useEffect, useState } from 'react';

// These pages are client-rendered (createRoot, no hydrateRoot), so we can read
// the real match on the first render instead of starting at false and flipping
// after mount. Starting at false caused a visible flash: components rendered
// desktop assets first, then swapped to mobile ones once the effect ran (e.g.
// the about/hero <video> showing desktop poster -> mobile poster -> mobile
// video). The window guard keeps it safe if ever imported without a DOM.
export function useMediaQuery(query: string) {
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches,
    );
    useEffect(() => {
        const mq = window.matchMedia(query);
        setMatches(mq.matches);
        const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [query]);
    return matches;
}
